export function resolveLocale(locale: string) {
  if (locale.includes('pt')) return 'pt'

  if (locale.includes('es')) return 'es'

  return 'en'
}

export function localeNumber(number: number, locale: string) {
  return new Intl.NumberFormat(locale).format(number)
}
